import React, {  useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"  
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT, LIMIT_PAGE } from "constants/variables";
import { es } from 'date-fns/locale';
import Box from '@mui/material/Box';  
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container'; 
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp"; 
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingRegisterBookFormDI from "pages/registerBook/editOrNewRegisterBook/SortingTablesRegisterBookFormDI";
import PropTypes from 'prop-types';
 
const initialFiltersFormDI= {
  "idFrom":"",
  "idTo":"",
  "preiddocSheetFrom":"",
  "preiddocSheetTo":"",
  "sufiddocSheetFrom":"",
  "sufiddocSheetTo":"",
  "numberDTFrom":"",
  "numberDTTo":"",
  "dateSheetFrom":null,
  "dateSheetTo":null
};
     
const initialStateFormDI = [{
  "id" : 0, 
  "ownformdi_id":0,
  "preiddoc_sheet" : "",
  "sufiddoc_sheet" : "", 
  "number_dt": "",
  "date_sheet" : "",
  "end_date_sheet" : "",
  "ori_tras_tradename" : "",
  "ori_tras_nima" : "",
  "ori_tras_postalcode" : "", 
  "opt_tras_tradename" : "",
  "opt_tras_nima" : "",
  "amount" : 0,
  "codeler" : "",
  "namecodeler" : "",
  "rel_trans_documentid": "",
  "rel_trans_tradename" : "", 
  "rel_trans_nima" : "",
  "rel_trans_licenseplate":"",
  "dest_tras_tradename" : "",
  "dest_tras_nima" : "",
  "dest_tras_inscription" : "", 
  "dest_tras_postalcode" : "", 
  "codetreatment" : "",
  "nametreatment" : "",
  "codedangerousness" : "", 
  "namedangerousness" : ""
}];  
 
const RegisterBookSearchDI = ({ showModalSearchDI, setShowModalSearchDI,formRegisterBook,setFormRegisterBook}) => {
  const {t,i18n} = useTranslation(['listDataRegisterBook']);
  const token = useSelector((state) => state.loginUser.token); 
  const defaultStore = useSelector((state) => state.loginUser.defaultStore);  
  const [dataFormDI, setDataFormDI] = useState(initialStateFormDI);
  const [isLoadingErrorFormDI, setIsLoadingErrorFormDI] = useState(false);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [inputTextFormDI, setInputTextFormDI] = useState("");
  const [applyFiltersFormiDI, setApplyFiltersFormiDI]= useState(initialFiltersFormDI);
  const [filtersFormDI, setFiltersFormDI]= useState(initialFiltersFormDI);
  const [openEditFilterFormDI,setOpenEditFilterFormDI]= useState(false);
  const [errorsfiltersFormDI, seterrorsfiltersFormDI] = useState({});
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegFormDI,setNumTotRegFormDI]= useState(0);
  const [activeOffsetFormDI, setActiveOffsetFormDI]= useState(false);
  const [currencyOffsetFormDI, setCurrencyOffsetFormDI] = useState(0);
  const [rangeOffsetFormDI, setRangeOffsetFormDI] = useState([{}]); 
  const dispatch = useDispatch(); 
   
  const handleCloseDataEditFormDI = () => {
    setDataFormDI(initialStateFormDI);
    setIsLoadingErrorFormDI(false);
    setInputTextFormDI("");
    setApplyFiltersFormiDI(initialFiltersFormDI);
    setFiltersFormDI(initialFiltersFormDI);
    setOpenEditFilterFormDI(false);
    seterrorsfiltersFormDI({});
    setNumTotRegFilter(0);
    setNumTotRegFormDI(0);
    setActiveOffsetFormDI(false);
    setCurrencyOffsetFormDI(0);
    setRangeOffsetFormDI([{}]); 
    setShowModalSearchDI(false)
	};

  const toggleDrawerSearchFormDI  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditFormDI();
    }
  };

  let inputHandlerFormDI = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextFormDI(lowerCase);
  };

  const openEditfiltersFormDI = () => {
    setFiltersFormDI(applyFiltersFormiDI);
    setOpenEditFilterFormDI(!openEditFilterFormDI);
  };

  const toggleDrawerFilterEditFormDI = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditFormDI();
    }
  };

  const handleCancelfiltersFormDI = () => {
    seterrorsfiltersFormDI({});
    setFiltersFormDI(initialFiltersFormDI);
    setOpenEditFilterFormDI(!openEditFilterFormDI);
  };

  const handleChangeFilterEditFormDi = (e) => {
    const { name, value } = e.target;
    setFiltersFormDI(filtersFormDI => ({
      ...filtersFormDI,
      [name]: value
    }));
  };

  const handleBlurFilterEditFormDI = (e) => {
    seterrorsfiltersFormDI(validateFormFilterFormDI());
    handleChangeFilterEditFormDi(e);
  };
 
  const handleSubmitFilterEditFormDI = () => {
    seterrorsfiltersFormDI(validateFormFilterFormDI());
    if (Object.keys(errorsfiltersFormDI).length === 0) {
      setApplyFiltersFormiDI(filtersFormDI);
      setFiltersFormDI(initialFiltersFormDI);
      seterrorsfiltersFormDI({});
      setOpenEditFilterFormDI(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeletefiltersFormDI = () => {
    seterrorsfiltersFormDI({});
    setFiltersFormDI(initialFiltersFormDI);
    setApplyFiltersFormiDI(initialFiltersFormDI);
    setOpenEditFilterFormDI(!openEditFilterFormDI);
  };

  const handleChangeSelectDateSheetFrom = (event) => {
    setFiltersFormDI(filtersFormDI => ({
      ...filtersFormDI,
      dateSheetFrom: event!==null?new Date(event):null,
      dateSheetTo:null
    }));
  };
 
  const handleBlurSelectDateSheetFrom = (e) => {
    handleChangeSelectDateSheetFrom(e);
    seterrorsfiltersFormDI(validateFormFilterFormDI());
  };

  const handleChangeSelectDateSheetTo = (event) => {
    setFiltersFormDI(filtersFormDI => ({
      ...filtersFormDI,
      dateSheetTo: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectDateSheetTo = (e) => {
    handleChangeSelectDateSheetTo(e);
    seterrorsfiltersFormDI(validateFormFilterFormDI());
  };

  const validateFormFilterFormDI = () => {

    let errorsfiltersFormDI = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersFormDI.idFrom!=="" & !regexNumber.test(filtersFormDI.idFrom)) {
      errorsfiltersFormDI.idFrom = 'Text_TextNoNumber';
    }
    if (filtersFormDI.idTo!=="" & !regexNumber.test(filtersFormDI.idTo)) {
      errorsfiltersFormDI.idTo = 'Text_TextNoNumber';
    }
    if (filtersFormDI.idFrom!=="" & !errorsfiltersFormDI.idFrom!==undefined){
      if (filtersFormDI.idTo!=="" & !errorsfiltersFormDI.idTo!==undefined){
        if (parseInt(filtersFormDI.idTo)<parseInt(filtersFormDI.idFrom)){
          errorsfiltersFormDI.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (regexInvalidCharacters.test(filtersFormDI.preiddocSheetFrom)) {
      errorsfiltersFormDI.preiddocSheetFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersFormDI.preiddocSheetTo)) {
      errorsfiltersFormDI.preiddocSheetTo = 'Text_TextNoValid';
    }
    
    if (filtersFormDI.sufiddocSheetFrom!=="" & !regexNumber.test(filtersFormDI.sufiddocSheetFrom)) {
      errorsfiltersFormDI.sufiddocSheetFrom = 'Text_TextNoNumber';
    }
    if (filtersFormDI.sufiddocSheetTo!=="" & !regexNumber.test(filtersFormDI.sufiddocSheetTo)) {
      errorsfiltersFormDI.sufiddocSheetTo = 'Text_TextNoNumber';
    } 

    if (regexInvalidCharacters.test(filtersFormDI.numberDTFrom)) {
      errorsfiltersFormDI.numberDTFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersFormDI.numberDTTo)) {
      errorsfiltersFormDI.numberDTTo = 'Text_TextNoValid';
    }

    if (filtersFormDI.preiddocSheetTo!=="" & filtersFormDI.preiddocSheetTo<filtersFormDI.preiddocSheetFrom){
      errorsfiltersFormDI.preiddocSheetTo = 'Text_TextGreater_PreiddocSheet';
    }

    if (filtersFormDI.sufiddocSheetTo!=="" & filtersFormDI.sufiddocSheetTo<filtersFormDI.sufiddocSheetFrom){
      errorsfiltersFormDI.sufiddocSheetTo = 'Text_TextGreater_SufiddocSheet';
    }

    if (filtersFormDI.numberDTTo!=="" & filtersFormDI.numberDTTo<filtersFormDI.numberDTFrom){
      errorsfiltersFormDI.numberDTTo = 'Text_TextGreater_numberDTTo';
    }
    return errorsfiltersFormDI;
  }   

  const filtereddataFormDI = dataFormDI.filter((el) => {
    if (inputTextFormDI === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.preiddoc_sheet || '') +
        String(el.sufiddoc_sheet || '') ;
      let result = dataTranslate.toLowerCase().includes(inputTextFormDI.toLowerCase());
      return result;
    }
  })

  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegFormDI = async () => {
      try { 
        const getData = await helpHttp().get2(ENDPOINT,`register/getinformationtableformdi/`,token,defaultStore.id);
        if (getData.err) {
          setDataFormDI(initialStateFormDI);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFormDI(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post2(ENDPOINT,`register/getcountfilterformdi`,token,defaultStore.id,applyFiltersFormiDI);
        if (getData.err || getData.message === "Load failed") {
          setDataFormDI(initialStateFormDI);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData')));  
      } 
    };

    const fetchdataFormDI = async () => { 
      try {
        const getData =  await helpHttp().post4(ENDPOINT,`register/getformsdi`,token,currencyOffsetFormDI,LIMIT_PAGE,defaultStore.id,applyFiltersFormiDI);
        if (getData.err || getData.message === "Load failed") {
          setDataFormDI(initialStateFormDI);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataFormDI(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    
    if (showModalSearchDI){
      fetchnumTotRegFormDI();
      fetchnumTotRegFilter();
      fetchdataFormDI();
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,defaultStore.id,applyFiltersFormiDI,currencyOffsetFormDI,showModalSearchDI]);
 
  return(
    <>
      {showModalSearchDI && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormDI(false)}
            onOpen={toggleDrawerSearchFormDI(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff', width: '1100px'}}>
                <br/>
                <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    {isLoadingErrorFormDI?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={"primary"}/>:<i className="fas fa-regular fa-clipboard text-warning"></i>} {t('Text_DIs_Search')}
                  </h1> 
                  <div>
                    <button type="button" className="formdi-pending-btn formdi-pending-btn--primary" onClick={handleCloseDataEditFormDI}>{t('Button_Back')}</button><> </>
                  </div> 
                </div>  
                <br/>   
                <div className="formdi-pending-search">
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    value={inputTextFormDI}
                    inputProps={{ style: {fontSize: '18px'} }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                    placeholder={t('Text_DI_Search')} 
                    onChange={inputHandlerFormDI}
                    fullWidth
                    label={t('Text_DI_Search')}>
                  </TextField>
                </div>
                <br/>
                <div id="myNewDIV" className="formdi-pending-filters">
                  <h1 className="formdi-pending-filter-title">{t('Text_Filter')}</h1> 
                    <div className="formdi-pending-filters-row">
                      <button type="button" className={`formdi-pending-chip ${applyFiltersFormiDI.idFrom !== "" || applyFiltersFormiDI.idTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersFormDI} >
                        <span className={`formdi-pending-dot ${ applyFiltersFormiDI.idFrom !== "" || applyFiltersFormiDI.idTo !== ""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_Code")}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${applyFiltersFormiDI.preiddocSheetFrom !== "" || applyFiltersFormiDI.preiddocSheetTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersFormDI} >
                        <span className={`formdi-pending-dot ${ applyFiltersFormiDI.preiddocSheetFrom !== "" || applyFiltersFormiDI.preiddocSheetTo !== ""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_Prefix")}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${applyFiltersFormiDI.sufiddocSheetFrom !== "" || applyFiltersFormiDI.sufiddocSheetTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersFormDI} >
                        <span className={`formdi-pending-dot ${ applyFiltersFormiDI.sufiddocSheetFrom !== "" || applyFiltersFormiDI.sufiddocSheetTo !== ""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_Sufix")}
                      </button>
                      <button type="button" className={`formdi-pending-chip ${applyFiltersFormiDI.numberDTFrom !== "" || applyFiltersFormiDI.numberDTTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersFormDI} >
                        <span className={`formdi-pending-dot ${ applyFiltersFormiDI.numberDTFrom !== "" || applyFiltersFormiDI.numberDTTo !== ""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_NumberNT")}
                      </button> 
                       <button type="button" className={`formdi-pending-chip ${applyFiltersFormiDI.dateSheetFrom!==null || applyFiltersFormiDI.dateSheetTo!==null ? "formdi-pending-chip--active": "" }`}  onClick={openEditfiltersFormDI} >
                        <span className={`formdi-pending-dot ${applyFiltersFormiDI.dateSheetFrom!==null || applyFiltersFormiDI.dateSheetTo!==null? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_Date")}
                      </button> 
                  </div>
                </div> 
                <br/> 
                {!isLoadingData ?
                  <>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content">  
                        <TableSortingRegisterBookFormDI
                          dataFormDI={filtereddataFormDI} 
                          numTotRegFilter={ numTotRegFilter}
                          titleTable={t('Text_DIs_AVAILABLE')}
                          numTotRegFormDI={numTotRegFormDI}
                          activeOffsetFormDI={activeOffsetFormDI}
                          rangeOffsetFormDI={rangeOffsetFormDI}
                          currencyOffsetFormDI={currencyOffsetFormDI}
                          setCurrencyOffsetFormDI={setCurrencyOffsetFormDI}
                          handleCloseDataEditFormDI={handleCloseDataEditFormDI} 
                          setFormRegisterBook={setFormRegisterBook}
                          formRegisterBook={formRegisterBook}
                        >
                      </TableSortingRegisterBookFormDI>
                      </div>             
                    </div>
                    {openEditFilterFormDI &&
                      <div>
                      <SwipeableDrawer
                        anchor='right'
                        open={true}
                        onClose={toggleDrawerFilterEditFormDI(false)}
                        onOpen={toggleDrawerFilterEditFormDI(true)}>
                        <Container >
                          <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '1100' }}>
                            <br/>
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div>
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <form className="newfilterformpruchasedi" onSubmit={handleCancelfiltersFormDI}>  
                                <div className="form-floating mb-3 px-4 primary">
                                  <div className="form-group">
                                    <TextField
                                      id="idFrom" 
                                      name="idFrom"
                                      value={filtersFormDI.idFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsfiltersFormDI.idFrom!=null?t(errorsfiltersFormDI.idFrom):t('Text_Filter_Code_From')}
                                      placeholder={t('Placeholder_Filter_Code_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDi}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="idTo" 
                                      name="idTo"
                                      value={filtersFormDI.idTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsfiltersFormDI.idTo!=null?t(errorsfiltersFormDI.idTo):t('Text_Filter_Code_To')}
                                      placeholder={t('Placeholder_Filter_Code_To')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDi}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="preiddocSheetFrom" 
                                      name="preiddocSheetFrom"
                                      value={filtersFormDI.preiddocSheetFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 20 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsfiltersFormDI.preiddocSheetFrom!=null?t(errorsfiltersFormDI.preiddocSheetFrom):t('Text_Filter_PreiddocSheet_From')}
                                      placeholder={t('Placeholder_Filter_PreiddocSheet_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDi}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="preiddocSheetTo" 
                                      name="preiddocSheetTo"
                                      value={filtersFormDI.preiddocSheetTo}inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 20 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsfiltersFormDI.preiddocSheetTo!=null?t(errorsfiltersFormDI.preiddocSheetTo):t('Text_Filter_PreiddocSheet_To')}
                                      placeholder={t('Placeholder_Filter_PreiddocSheet_To')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDi}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="sufiddocSheetFrom" 
                                      name="sufiddocSheetFrom"
                                      value={filtersFormDI.sufiddocSheetFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsfiltersFormDI.sufiddocSheetFrom!=null?t(errorsfiltersFormDI.sufiddocSheetFrom):t('Text_Filter_SufiddocSheet_From')}
                                      placeholder={t('Placeholder_Filter_SufiddocSheet_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDi}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="sufiddocSheetTo" 
                                      name="sufiddocSheetTo"
                                      value={filtersFormDI.sufiddocSheetTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsfiltersFormDI.sufiddocSheetTo!=null?t(errorsfiltersFormDI.sufiddocSheetTo):t('Text_Filter_SufiddocSheet_To')}
                                      placeholder={t('Placeholder_Filter_SufiddocSheet_To')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDi}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="numberDTFrom" 
                                      name="numberDTFrom"
                                      value={filtersFormDI.numberDTFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsfiltersFormDI.numberDTFrom!=null?t(errorsfiltersFormDI.numberDTFrom):t('Text_Filter_NumberNT_From')}
                                      placeholder={t('Placeholder_Filter_NumberNT_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDi}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="numberDTTo" 
                                      name="numberDTTo"
                                      value={filtersFormDI.numberDTTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 15 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsfiltersFormDI.numberDTTo!=null?t(errorsfiltersFormDI.numberDTTo):t('Text_Filter_NumberNT_To')}
                                      placeholder={t('Placeholder_Filter_NumberNT_To')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDi}/>
                                  </div>

                                  <div className="form-group">
                                 <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                      <DesktopDatePicker
                                        id="dateSheetFrom" 
                                        name="dateSheetFrom"
                                        value={ filtersFormDI.dateSheetFrom!== null ? new Date(filtersFormDI.dateSheetFrom): null}
                                        format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                        label={errorsfiltersFormDI.dateSheetFrom!=null?t(errorsfiltersFormDI.dateSheetFrom):t('Placeholder_Filter_DateSheet_From')}
                                        onBlur={handleBlurSelectDateSheetFrom}
                                        onChange={handleChangeSelectDateSheetFrom}
                                        slotProps={{
                                          textField: {
                                            placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                            sx: {
                                              maxLength: 100,
                                              width: 430,
                                              fontSize: '18px',  
                                            },
                                            InputProps: {
                                              style: {
                                                fontSize: '18px',
                                              }
                                            },
                                            InputLabelProps:{ 
                                              style: {
                                                fontSize: '18px', 
                                                background: '#FFFFFF'
                                              }
                                            },
                                          },
                                        }}
                                      />
                                    </LocalizationProvider>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                                   <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                      <DesktopDatePicker
                                        id="dateSheetTo" 
                                        name="dateSheetTo"
                                        minDate={filtersFormDI.dateSheetFrom!== null ? new Date(filtersFormDI.dateSheetFrom): null}
                                        value={ filtersFormDI.dateSheetTo!== null ? new Date(filtersFormDI.dateSheetTo): null}
                                        format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                        label={errorsfiltersFormDI.dateSheetTo!=null?t(errorsfiltersFormDI.dateSheetTo):t('Placeholder_Filter_DateSheet_To')}
                                        onBlur={handleBlurSelectDateSheetTo}
                                        onChange={handleChangeSelectDateSheetTo}
                                        slotProps={{
                                          textField: {
                                            placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                            sx: {
                                              maxLength: 100,
                                              width: 430,
                                              fontSize: '18px',  
                                            },
                                            InputProps: {
                                              style: {
                                                fontSize: '18px',
                                              }
                                            },
                                            InputLabelProps:{ 
                                              style: {
                                                fontSize: '18px', 
                                                background: '#FFFFFF'
                                              }
                                            },
                                          },
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </div>
                                   
                                </div>
                                <hr className="sidebar-divider d-none d-md-block"/>
                                <div className="formdi-pending-action-group">
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditFormDI}>
                                    {t('Button_Apply')}
                                  </button> 
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeletefiltersFormDI}>
                                    {t('Button_Cancel_Filters')}
                                  </button>
                                </div>  
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>
                  }  
                  
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>
                }
                
                
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

RegisterBookSearchDI.propTypes = {
  showModalSearchDI: PropTypes.bool.isRequired,
  setShowModalSearchDI: PropTypes.func.isRequired,
  setFormRegisterBook: PropTypes.func.isRequired
};

export default RegisterBookSearchDI;

